const initialState = {
  fetching: false,
};

export default function planInsertionReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'PLAN_INSERTION':
      return { ...currentState, fetching: true };
    case 'PLAN_INSERTED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
